export default {
  path: '/fleet/settings/organizational-unit',
  name: 'OrganizationalUnit',
  component: () => import(/* webpackChunkName: "base" */ '../views/OrganizationalUnitView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
